const styles = {
  global: {
    '.grecaptcha-badge': {
      bottom: '128px !important',
    },
  }
}

export default styles
